import { Switch } from '@arco-design/web-react'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ReactComponent as Feat3 } from 'ASSETS/svg/icon_feat_3.svg'
import { ReactComponent as IconMask } from 'ASSETS/svg/icon_mask.svg'

import feat31 from 'ASSETS/png/feat3_1.png'
import feat32 from 'ASSETS/png/feat3_2.png'
import feat33 from 'ASSETS/png/feat3_3.png'
import feat34 from 'ASSETS/png/feat3_4.png'

const FeatContainer3 = () => {
  const [scale, setScale] = useState(1)
  const [opcity, setOpcity] = useState(0)
  const [check, setCheck] = useState(false)
  const [showAll, setShowAll] = useState(false)
  const [smallScale, setSmallScale] = useState(0.8)

  const init = () => {
    setScale(1)
    setOpcity(0)
    setShowAll(false)
    setCheck(false)
    setSmallScale(0.8)
  }

  const start = () => {
    setOpcity(1)
  }
  useEffect(() => {
    if (opcity === 1) {
      setScale(1.3)
    }
  }, [opcity])

  useEffect(() => {
    if (scale === 1.3) {
      setTimeout(() => {
        setCheck(true)
      }, 800)
    }
  }, [scale])

  useEffect(() => {
    if (check) {
      setTimeout(() => {
        setShowAll(true)
        setSmallScale(1)
      }, 800)
      setTimeout(() => {
        init()
      }, 1800)
      setTimeout(() => {
        start()
      }, 2800)
    }
  }, [check])

  useEffect(() => {
    start()
  }, [])

  return (
    <Container>
      <IconFeat3></IconFeat3>
      <div style={{ alignSelf: 'flex-start', marginTop: '24px' }}>
        <FeatTitle>使用</FeatTitle>
        <FeatActiveTitle>便捷</FeatActiveTitle>
      </div>
      <FeatContent>
        产品界面设计简洁，操作便捷，上传您需优化的图片后，仅需通过简单点击和配置操作，即可获得优化后的图片效果，同时支持多张图片批量操作。
      </FeatContent>
      <Feat3Cube></Feat3Cube>
      <Feat31ImageContaienr>
        <img
          src={feat31}
          style={{
            borderRadius: '8px',
            width: '100%',
            height: '100%',
            position: 'absolute',
          }}
        ></img>
        <div style={{ opacity: opcity }}>
          <IconMask
            style={{
              width: '222px',
              height: '56px',
              transform: `scale(${scale})`,
              transition: 'transform 0.6s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
            }}
          ></IconMask>
        </div>
      </Feat31ImageContaienr>
      <Feat32ImageContaienr>
        <IconMask
          style={{
            width: '112px',
            height: '28px',
            opacity: showAll ? '1' : 0,
            transform: `scale(${smallScale})`,
            transition: 'transform 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
          }}
        ></IconMask>
      </Feat32ImageContaienr>
      <Feat33ImageContaienr>
        <IconMask
          style={{
            width: '112px',
            height: '28px',
            opacity: showAll ? '1' : 0,
            transform: `scale(${smallScale})`,
            transition: 'transform 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
          }}
        ></IconMask>
      </Feat33ImageContaienr>
      <Feat34ImageContaienr>
        <IconMask
          style={{
            width: '112px',
            height: '28px',
            opacity: showAll ? '1' : 0,
            transform: `scale(${smallScale})`,
            transition: 'transform 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
          }}
        ></IconMask>
      </Feat34ImageContaienr>
      <SwitchContainer>
        <Switch checked={check} style={{ marginRight: '20px' }}></Switch>
        <SwitchText>将当前模版应用到所有图片</SwitchText>
      </SwitchContainer>
    </Container>
  )
}

const Container = styled.div`
  width: 343px;
  display: flex;
  height: 582px;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const IconFeat3 = styled(Feat3)`
  margin-top: 40px;
  align-self: flex-start;
  width: 40px;
  height: 40px;
  box-shadow: 1px 4px 20px rgba(184, 213, 240, 0.3);
  border-radius: 20px;
`

const FeatTitle = styled.span`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
  color: #282f38;
`

const FeatActiveTitle = styled(FeatTitle)`
  color: #3370ff;
`

const FeatContent = styled.div`
  width: 323px;
  margin: 16px 0 32px 0;
  align-self: flex-start;
  font-size: 14px;
  line-height: 22px;
  color: #4e5a83;
  opacity: 0.8;
`

const Feat3Cube = styled.div`
  width: 270px;
  height: 266px;
  background: #f1f7ff;
  border-radius: 6px;
  align-self: flex-end;
`

const Feat31ImageContaienr = styled.div`
  position: absolute;
  top: 273px;
  left: 23px;
  width: 392px;
  height: 416px;
  filter: drop-shadow(0px 80px 98px rgba(217, 225, 250, 0.17)),
    drop-shadow(0px 33px 12px rgba(180, 190, 221, 0.12));
  border-radius: 12px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  transform: scale(0.5);
  transform-origin: top left;
`

const Feat32ImageContaienr = styled.div`
  position: absolute;
  top: 274px;
  left: 224px;
  background: url(${feat32});
  width: 170px;
  height: 156px;
  border-radius: 8px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.5);
  transform-origin: top left;
`

const Feat33ImageContaienr = styled.div`
  position: absolute;
  top: 358px;
  left: 224px;
  background: url(${feat33});
  width: 190px;
  height: 120px;
  border-radius: 8px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.5);
  transform-origin: top left;
`

const Feat34ImageContaienr = styled.div`
  position: absolute;
  top: 424px;
  left: 224px;
  background: url(${feat34});
  width: 150px;
  height: 116px;
  border-radius: 8px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.5);
  transform-origin: top left;
`

const SwitchContainer = styled.div`
  height: 72px;
  width: 490px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
  position: absolute;
  top: 459px;
  left: 77px;
  filter: drop-shadow(0px 80px 64px rgba(193, 198, 215, 0.17));
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  :before {
    border: 1px solid transparent;
  }
  transform: scale(0.5);
  transform-origin: top left;
`

const SwitchText = styled.div`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #282f38;
`

export default FeatContainer3
